// @flow

import type {Calculation, HeroCalculation} from '../utils/stats_calculator';
import {Modal, Table, Typography} from 'antd';
import React from 'react';
import calculator from '../utils/stats_calculator';
import {withRouter} from 'react-router';
import type {Hero} from '../data/heroes';

const {Title} = Typography;

type Props = {
  heroes: Array<Hero>,
  isVisible: boolean,
  onOK: ()=>void
};

const columns = [
  {
    title: 'Effect',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Calculation',
    dataIndex: 'formula',
    key: 'formula',
  },
  {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
  },
];


function CalculationResultDialog({heroes, isVisible, onOK}: Props) {
  const result = calculator.calculate(heroes);
  return <Modal
    title={"Team: " + result.map((r: HeroCalculation) => r.hero.name)
      .join(', ')}
    visible={isVisible}
    onOk={onOK}
    onCancel={onOK}
  >
    {heroes != null &&
    result.map((r: HeroCalculation, i: number) => {
      return <div key={i}>
        <Title level={3}>{r.hero.name}</Title>
        <Table
          pagination={{hideOnSinglePage: true}}
          columns={columns}
          dataSource={[
            ...r.atkCalculation,
            {
              name: 'Subtotal',
              formula: r.atkCalculation
                .map((cal: Calculation) => cal.value)
                .join(' + '),
              value: r.atkTotal,
            },
          ]}
        />
      </div>;
    })}
  </Modal>
}

export default withRouter(CalculationResultDialog);

